import * as Yup from "yup";

export type questionIp = {
  state_id: string;
  college_id: string;
  ipAddress: string;
  status: string;
  expiry: string;
};

export const questionIpInitialValues: questionIp = {
  state_id: "",
  college_id: "",
  ipAddress: "",
  status: "active",
  expiry: "",
};

export const questionIpMandatoryFields = [
  { id: "state_id" },
  { id: "college_id" },
  { id: "ipAddress" },
  { id: "status" },
];

export const questionIpValidationSchema = Yup.object().shape({
  state_id: Yup.string().required("state is required"),
  college_id: Yup.string().required("college is required"),
  ipAddress: Yup.string()
    .required("IP address is required")
    .test("is-ip", "Enter a valid IPv4 or IPv6 address", (value) => {
      if (!value) return false;

      // IPv4 pattern
      const ipv4Pattern =
        /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;

      // IPv6 pattern
      const ipv6Pattern =
        /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]+|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;

      return ipv4Pattern.test(value) || ipv6Pattern.test(value);
    }),
  status: Yup.string().required("status is required"),
});

export const questionIpProperties = [
  {
    id: "state_id",
    type: "single-select-dependency",
    label: "State *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    required: true,
    list: "state_list",
    keyValue: { label: "state_name", value: "state_id" },
    dependentFields: ["college_list"],
    dependentFlds: {
      state_list: "state_list",
    },
  },
  {
    id: "college_id",
    type: "single-select-dependency",
    label: "College *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    options: [],
    list: "college_list",
    dependencyLabel: "Please select State",
    keyValue: { label: "college_name", value: "college_id" },
    fieldKeyLists: {},
  },
  {
    id: "ipAddress",
    type: "text",
    label: `IP Address`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "active" },
      { label: "Deactivated", value: "deactivated" },
    ],
    hideNone: true,
  },
  {
    id: "expiry",
    type: "date-time-picker",
    label: "Expiry",
    className: "name-styles",
    required: false,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
  },
];

export const table = {
  primaryData: [
    {
      title: "State",
      value: "stateName",
      type: "configue",
    },
    {
      title: "College",
      value: "collegeName",
      type: "configue",
    },
    {
      title: "ipAddress",
      value: "ipAddress",
      type: "configue",
    },
    {
      title: "Status",
      value: "status",
    },
    {
      title: "Expiry",
      value: "expiry",
      type: "configue",
    },
    {
      title: "Actions",
      width: "5%",
      sendIsArchived: true,
    },
  ],
  secondaryData: [
     {
      title: "Created At",
      value: "createdAt",
    },
    {
      title: "Updated At",
      value: "updatedAt",
    },
    {
      title: "Created By",
      value: "createdByName",
      type: "configue",
    },
    {
      title: "Updated By",
      value: "updatedByName",
      name: "update",
    },
  ],
};

export const tableRead = {
  primaryData: [
    {
      title: "College ID",
      value: "collegeObjectId",
      type: "configue",
    },
    {
      title: "ipAddress",
      value: "ipAddress",
      type: "configue",
    },
    {
      title: "Status",
      value: "status",
    },
    {
      title: "Expiry",
      value: "expiry",
      type: "configue",
    },
    {
      title: "Created At",
      value: "createdAt",
      type: "configue",
    },
    {
      title: "Updated At",
      value: "updatedAt",
      type: "configue",
    },
    {
      title: "Created By",
      value: "createdByName",
      type: "configue",
    },
    {
      title: "Updated By",
      value: "updatedByName",
      name: "update",

      type: "configue",
    },
  ],
  secondaryData: [],
};

export function getValuesByIds(ids, objects, key = "name", key_id) {
  // Create a lookup (dictionary) for faster access
  return ids.map((id) => {
    const found = objects.find((obj) => obj[key_id] === id);
    return found ? found[key] : null;
  });
}

export const formatExpiry = (expiry) => {
  if (!expiry) return "";

  const d = new Date(expiry);

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ` +
         `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}:${String(d.getSeconds()).padStart(2, "0")}`;
};
